var map = {
	"./btc.png": 481,
	"./cashapp.png": 2014,
	"./credit.png": 7833,
	"./csgo.png": 2186,
	"./dota.png": 6864,
	"./eth.png": 9389,
	"./g2a.png": 5844,
	"./gift.png": 7088,
	"./kinguin.png": 9307,
	"./limiteds.png": 7083,
	"./ltc.png": 1727,
	"./placeholder.png": 6839,
	"./robux.png": 9474,
	"./usdc.png": 9441,
	"./usdt.png": 4462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7493;